import {Doughnut} from 'react-chartjs-2';
import {ArcElement, Chart as ChartJS, type ChartOptions, Legend, type Plugin, Tooltip} from 'chart.js';
import { useTranslation } from 'react-i18next';

type DataTableProps = {
    chartData: Data;
    remain: string;
};

interface Data {
    labels: never[];
    datasets: { backgroundColor: string[]; borderColor: string[]; data: number[]; borderWidth: number }[];
}


ChartJS.register(ArcElement, Tooltip, Legend);

const FONT_FAMILY = 'Montserrat, Spoqa Han Sans Neo';

const PricingChart = ({chartData, remain}: DataTableProps) => {
    const { t } = useTranslation('ui');

    const centerTextPlugin: Plugin<'doughnut'> = {
        id: 'centerText',
        afterDatasetsDraw(chart) {
            const { ctx, chartArea: { width, height } } = chart;

            ctx.save();
            const lines = [t('userInfo.daysRemaining'), remain];
            const colors = ["#585757", "#264EDD"];
            const fontSizes = [21, 18];
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            const centerX = width / 2;
            const centerY = height / 2;

            lines.forEach((line, index) => {
                const fontSize = fontSizes[index];
                ctx.font = `${fontSize}px ${FONT_FAMILY}`;
                const lineHeight = fontSize * 1.2;
                const y = centerY - ((lines.length - 1) / 2) * lineHeight + index * lineHeight;


                ctx.fillStyle = colors[index];
                ctx.fillText(line, centerX, y);
            });

            ctx.restore();
        },
    };

    const options: ChartOptions<'doughnut'> = {
        cutout: "73%",
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        },
        responsive: true,
        maintainAspectRatio: false,
    };

    return (
        <Doughnut className="chart_box mx-auto" data={chartData} options={options} plugins={[centerTextPlugin]}/>
    );
};

export default PricingChart;